import { service } from '.';

export default {
  onLoadGetOne: (id) => service.get(`/counting/on_load/${id}`),
  onLoad: (data) => service.post('/counting/on_load', data),
};
